import { render, staticRenderFns } from "./ClaimsEdit.vue?vue&type=template&id=2febc5a2&scoped=true&"
import script from "./ClaimsEdit.vue?vue&type=script&lang=js&"
export * from "./ClaimsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2febc5a2",
  null
  
)

export default component.exports